import { jsx as d, jsxs as I } from "react/jsx-runtime";
import { useState as m, useCallback as h, useEffect as z } from "react";
import { Icon as O } from "@southfields-digital/mxmz-react-ui";
function x(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var w = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var y;
function S() {
  return y || (y = 1, (function(e) {
    (function() {
      var r = {}.hasOwnProperty;
      function s() {
        for (var t = "", n = 0; n < arguments.length; n++) {
          var i = arguments[n];
          i && (t = o(t, u(i)));
        }
        return t;
      }
      function u(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return s.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var n = "";
        for (var i in t)
          r.call(t, i) && t[i] && (n = o(n, i));
        return n;
      }
      function o(t, n) {
        return n ? t ? t + " " + n : t + n : t;
      }
      e.exports ? (s.default = s, e.exports = s) : window.classNames = s;
    })();
  })(w)), w.exports;
}
var b = S();
const R = /* @__PURE__ */ x(b), W = "_Button_18f7v_1", B = "_Hidden_18f7v_10", C = {
  Button: W,
  Hidden: B
}, D = ({ isHidden: e, onClick: r, title: s }) => /* @__PURE__ */ d(
  "button",
  {
    type: "button",
    className: R(C.Button, { [C.Hidden]: e }),
    onClick: r,
    tabIndex: e ? -1 : void 0,
    "aria-hidden": e,
    title: s,
    children: /* @__PURE__ */ d(O, { icon: "diamond", size: 22, weight: "bold" })
  }
), L = 320, P = 480, E = 360, H = "aiassist:panelwidth", g = (e) => Math.min(P, Math.max(L, Math.round(e))), M = () => {
  try {
    const e = localStorage.getItem(H);
    return e ? g(Number(JSON.parse(e))) : E;
  } catch {
    return E;
  }
}, T = () => {
  const [e, r] = m(!1), [s, u] = m(M), [o, t] = m(!1), [n, i] = m(null), v = h(() => r(!0), []), p = h(() => r(!1), []), A = h(() => r((a) => !a), []), f = h(
    (a) => {
      a.preventDefault(), i({ x: a.clientX, width: s }), t(!0);
    },
    [s]
  );
  return z(() => {
    try {
      localStorage.setItem(H, JSON.stringify(s));
    } catch {
    }
  }, [s]), z(() => {
    if (!o || !n) return;
    const a = (_) => {
      u(g(n.width + (n.x - _.clientX)));
    }, l = () => {
      i(null), t(!1);
    };
    return window.addEventListener("pointermove", a), window.addEventListener("pointerup", l), () => {
      window.removeEventListener("pointermove", a), window.removeEventListener("pointerup", l);
    };
  }, [o, n]), {
    isOpen: e,
    open: v,
    close: p,
    toggle: A,
    width: g(s),
    isResizing: o,
    startResize: f
  };
}, j = "_Container_2ffee_1", K = "_ContainerWithButton_2ffee_6", X = "_Content_2ffee_10", k = "_Rail_2ffee_14", q = "_RailResizing_2ffee_19", F = "_ResizeHandle_2ffee_23", J = "_ResizeHandleActive_2ffee_29", c = {
  Container: j,
  ContainerWithButton: K,
  Content: X,
  Rail: k,
  RailResizing: q,
  ResizeHandle: F,
  ResizeHandleActive: J
}, V = ({
  children: e,
  renderPanel: r,
  label: s = "Ask",
  buttonTitle: u,
  isAvailable: o = !0
}) => {
  const { isOpen: t, open: n, close: i, width: v, isResizing: p, startResize: A } = T(), f = t && o, a = (l) => {
    const _ = l.target, N = _ instanceof HTMLTextAreaElement && _.value.length > 0;
    l.key === "Escape" && !N && (l.stopPropagation(), i());
  };
  return /* @__PURE__ */ I("div", { className: R(c.Container, { [c.ContainerWithButton]: o }), children: [
    /* @__PURE__ */ d("div", { className: c.Content, children: e }),
    f && /* @__PURE__ */ d(
      "div",
      {
        role: "separator",
        "aria-orientation": "vertical",
        "aria-label": `Resize ${s}`,
        tabIndex: 0,
        className: R(c.ResizeHandle, {
          [c.ResizeHandleActive]: p
        }),
        onPointerDown: A
      }
    ),
    /* @__PURE__ */ d(
      "div",
      {
        className: R(c.Rail, { [c.RailResizing]: p }),
        style: { width: f ? v : 0 },
        onKeyDown: a,
        children: f && r(i)
      }
    ),
    o && /* @__PURE__ */ d(D, { isHidden: t, onClick: n, title: u ?? s })
  ] });
};
export {
  E as A,
  P as a,
  L as b,
  D as c,
  V as d,
  R as e,
  T as u
};
//# sourceMappingURL=AiAssistRail-Cjw4mUF4.js.map
